/*
 * @Description: 风控通用 其中ajax 通过组件中注册
 * @Date: 2019-09-16 11:22:48
 */
import XCurrency from '../components/common/currency';
import XTag from '../components/common/tag';
import XCheckbox from '../components/common/checkbox';
import XSwitch from '../components/common/switch';
import { getStorage } from '@/tools/storage';
import { riskControl } from '@/api/ajax';
import dateFormat from '@/tools/dateFormat';

export default {
  provide() {
    return {
      parent: this
    };
  },
  components: {
    XCurrency,
    XTag,
    XCheckbox,
    XSwitch
  },
  data() {
    return {
      id: null,
      user: {},
      range: {},
      isEdit: false, // 是否修改状态 true 修改状态
      ruleForm: {
        riskBaseControlDistanceList: []
      },
      visitTimeRange: {
        max: '9999',
        min: '0'
      },
      // 时间选择器配置
      timeSelectOptions: {
        // start: "00:00",
        // end: "23:59",
        // step: "00:01"
        format: 'HH:mm'
      },
      datePickerValue: '',
      list: [],
      rules: {},
      ajaxjResponse: {}
    };
  },
  inject: {
    riskIndex: {
      default: {}
    }
  },
  computed: {
    enableDtForm() {
      if (this.sceneControlKey && this.ruleForm[this.sceneControlKey]) {
        let d = this.ruleForm[this.sceneControlKey].enableDt;
        return dateFormat(d);
      }
    },
    showYesNo() {
      return (yes, no) => {
        const arr = [];
        yes && arr.push('能');
        no && arr.push('否');
        return arr.join('，');
      };
    },
    validVisitPeople() {
      return (
        min,
        max,
        tips = {
          empty: '请输入拜访医生人次',
          notInteger: '医生人次需为正整数，请调整',
          tooMin: `医生人次最少为${min}人`,
          tooMax: `医生人次最少为${max}人`
        }
      ) => {
        return [
          {
            validator: (rule, value, callback) => {
              if (!value && value !== 0) {
                callback(tips.empty || '请输入拜访医生人次');
              } else if (!/^[0-9]\d*$/.test(value)) {
                callback(tips.notInteger || '医生人次需为正整数，请调整');
              } else if (value < min) {
                callback(tips.tooMin || `医生人次最少为${min}人`);
              } else if (value > max) {
                callback(tips.tooMax || `医生人次最多为${max}人`);
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ];
      };
    },
    validVisitDay() {
      return (min, max) => {
        return [
          {
            validator: (rule, value, callback) => {
              if (!value && value !== 0) {
                callback('请输入天数');
              } else if (!/^[0-9]\d*$/.test(value)) {
                callback('天数需为正整数，请调整');
              } else if (value < max) {
                callback(`天数最少为${max}天`);
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ];
      };
    },
    validVisitPeople2() {
      /**
       * @param {min} 最小值
       * @param {obj} 当前存值对象
       */

      return (min, obj, cantSet) => {
        return [
          {
            validator: (rule, _value, callback) => {
              const value = typeof obj !== 'undefined' ? obj.dayDoctor : _value; // FIXME: wjx 修复部分地方调用该方法时,取当前绑定值
              if (cantSet) {
                callback();
              }
              if (!value && value !== 0) {
                callback('请输入天数');
              } else if (!/^[0-9]\d*$/.test(value)) {
                callback('天数需为正整数，请调整');
              } else if (value < min) {
                callback(`天数最少为${min}日`);
              } else if (value > 365) {
                callback('天数最多为365日');
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ];
      };
    },
    //时间段题rule
    validTimeSlotQuestion() {
      return obj => {
        let { visitTimeStart, visitTimeEnd } = obj;
        let { max, min } = this.visitTimeRange;

        return [
          {
            required: true,
            validator: (rule, value, callback) => {
              visitTimeStart = visitTimeStart === 0 ? '0' : visitTimeStart;
              if (!visitTimeStart || !visitTimeEnd) {
                callback(new Error(`最小值为${min}，最大值为${max}`));
              } else if (+visitTimeStart < min || +visitTimeEnd > max) {
                callback(new Error(`最小值为${min}，最大值为${max}`));
              } else if (
                +visitTimeStart > +visitTimeEnd ||
                +visitTimeEnd === 0
              ) {
                callback(new Error('请检查是否输入正确的区间'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ];
      };
    },
    validVisitPeople3() {
      return (max, obj, cantSet) => {
        return [
          {
            validator: (rule, _value, callback) => {
              const value = obj.monthCustomerMostNumber;
              if (cantSet) {
                callback();
              }
              if (!value && value !== 0) {
                callback('请输入次数');
              } else if (!/^[0-9]\d*$/.test(value)) {
                callback('次数需为正整数，请调整');
              } else if (value < 1) {
                callback('次数最少为1次');
              } else if (value > max) {
                callback(`次数最多为${max}次`);
              } else if (value > 999) {
                callback('次数最多为999次');
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ];
      };
    },
    validVisitcommon() {
      return (min, max, r = '次') => {
        return [
          {
            validator: (rule, value, callback) => {
              if (!value && value !== 0) {
                callback('请输入' + r + '数');
              } else if (!/^[0-9]\d*$/.test(value)) {
                callback(`${r}数需为正整数，请调整`);
              } else if (value < min) {
                callback(`${r}数最少为${min}`);
              } else if (value > max) {
                callback(`${r}数最多为${max}`);
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ];
      };
    },
    validVisitTime() {
      return (min, max, nowMin, nowMax, canUpdate) => {
        return [
          {
            validator: (rule, value, callback) => {
              if (!canUpdate) {
                callback();
              }
              if (!nowMin) {
                callback('请选择开始时间');
              }
              if (!nowMax) {
                callback('请选择结束时间');
              }
              if (min > max) {
                const getTimestamp = (str, plus) =>
                  new Date(`2019-10-${plus ? 2 : 1} ${str}`).getTime();
                const isMinNext = nowMin < min && nowMin <= max;
                const isMaxNext = nowMax < min && nowMax <= max;
                const nowMinTime = getTimestamp(nowMin, isMinNext);
                const nowMaxTime = getTimestamp(nowMax, isMaxNext);
                const minTime = getTimestamp(min);
                const maxTime = getTimestamp(max, true);
                const tips = `起止时间范围${min}-${max}(次日)`;
                if (nowMinTime > nowMaxTime) {
                  callback(tips);
                } else if (nowMinTime < minTime) {
                  callback(tips);
                } else if (nowMaxTime > maxTime) {
                  callback(tips);
                } else {
                  callback();
                }
              } else {
                if (nowMin > nowMax) {
                  callback('起时间需小于止时间，请调整');
                } else if (nowMin < min) {
                  callback(`拜访时间不能小于${min}`);
                } else if (nowMax > max) {
                  callback(`拜访时间不能大于${max}`);
                } else {
                  callback();
                }
              }
            },
            trigger: 'change'
          }
        ];
      };
    },
    validRadioRange() {
      return (yes, no) => {
        const arr = [];
        yes && arr.push(1);
        no && arr.push(0);
        return [
          {
            validator: (rule, value, callback) => {
              if (arr.indexOf(value) < 0) {
                callback('请修改为可调范围内');
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ];
      };
    }
  },
  filters: {
    time(timesting) {
      return dateFormat(timesting, 'HH:mm:ss');
    },
    number(numberstring) {
      return parseInt(numberstring);
    }
  },
  methods: {
    closeDialog() {
      this.$parent.findThing = '';
      this.$parent.showDialog = false;
    },
    creatRule() {
      let list = {};

      this.rules = list;
    },
    record() {
      //点击风控记录
      this.$parent.findThing = 'dialogRisk';
      this.$parent.listAjax = riskControl[this.$parent.curr];
      setTimeout(() => {
        this.$parent.showDialog = true;
      }, 100);
    },
    save() {
      let option = this.$parent.currOption;
      let curr = this.$parent.curr;
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          try {
            let obj = JSON.stringify({
              projectId: +(this.id || 0),
              enterpriseId: +this.user.enterpriseId,
              [option['base']]: this.ruleForm || {}
            });
            let query = { jsonData: obj };
            let operation = () => {
              riskControl[curr]
                .update(query)
                .then(() => {
                  this.$message.success('操作成功');
                })
                .catch(() => {});
            };
            this.makeSureEvent(operation, null, '确定修改?');
          } catch (e) {
            console.error('解析json有误');
          }
        }
      });
    },
    init() {
      let option = this.$parent.currOption;
      let curr = this.$parent.curr;
      let { id } = this.$route.query;
      this.id = id || 0;
      this.user = getStorage('user');
      // this.user.enterpriseId
      riskControl[curr]
        .detail({
          projectId: +id,
          enterpriseId: this.user.enterpriseId
        })
        .then(res => {
          let target = res.data.data;
          this.ajaxjResponse = target;
          this.ruleForm = target[option['saas']] || target[option['base']];
          this.list = target.riskBaseControlDistanceList || [];
          let object = Object.assign({}, target);
          delete object[option['saas']];
          delete object[option['base']];
          delete object.riskBaseControlDistanceList;
          this.range = object;
          if (!this.ruleForm) {
            this.ruleForm = Object.assign({}, object);
          }
          delete this.range.tsaasMakeSceneBaseProject;
          delete this.ruleForm.tsaasMakeSceneBaseProject;
          if (
            Object.prototype.toString.call(this.initCallback) ==
            '[object Function]'
          ) {
            // 初始化回调
            this.initCallback();
          }
          const formDom = this.$refs['ruleForm'];
          if (
            formDom &&
            Object.prototype.toString.call(formDom.validate) ==
              '[object Function]'
          ) {
            setTimeout(() => {
              formDom.validate();
            }, 500);
          }
          //关于拜访时长限制
          this.visitTimeRange.max = JSON.parse(
            JSON.stringify(target.visitTimeEnd)
          );
          this.visitTimeRange.min = JSON.parse(
            JSON.stringify(target.visitTimeStart)
          );
        })
        .catch(e => {
          console.error(e);
        });
    }
  },
  created() {
    if (this.isDialog) {
      try {
        // 获取父级注入信息
        this.ajaxjResponse = this.riskIndex.$refs['riskEditView'].ajaxjResponse;
      } catch (err) {
        console.error(err);
      }

      this.ruleForm = this.obj;
      // eslint-disable-next-line no-prototype-builtins
      if (this.ruleForm.hasOwnProperty('customerRiskType')) {
        this.range['customerRiskType'] = this.ruleForm.customerRiskType;
      }
      // this.range = this.obj.baseRiskObj || {};
      this.list = this.listobj;

      // 患者类型特殊处理
      this.initPatient(this.ruleForm);

      return;
    }
    this.init();
  },
  beforeDestroy() {
    this.ruleForm = {};
    this.range = {};
    this.rules = {};
  }
};
